import { Popper } from "@material-ui/core";
import { Box, margin } from "@mui/system";
import React, { useEffect, useRef } from "react";

const TabelPopover = ({
  setOpenModal = () => {},
  openModal,
  width,
  zIndex,
  children,
}) => {
  const popupRef = useRef(null);
  const style = {
    position: "absolute",
    left: "-15rem",
    transform: "translate(-50%, -50%)",
    width: width ? width : 300,
    background: "rgba(255, 255, 255, 1)",
    boxShadow: "0px 4px 15px rgba(0, 0, 0, 0.25)",
    borderRadius: "10px",
    p: 2,
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setOpenModal(false);
      }
    };
    if (openModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [openModal, setOpenModal]);
  return (
    <Box sx={style} ref={popupRef}>
      {children}
    </Box>
  );
};

export default TabelPopover;
